<footer>
    <div class="footer_inner">
        <div class="footer_text">
            <div class="logo">
                <img src="assets/images/logo-footer.svg" alt="">
            </div>
            <p>Your Co-Pilot for every dream</p>
        </div>

        <div class="footer_links">
            <ul>
                <li>
                    <a href="https://www.gradpilots.com/mentor-me.html">Find mentors</a>
                    <!-- <a routerLink="/">Become a mentor</a> -->
                    <a [routerLink]="['/mentor-signup']">Become a mentor</a>
                    <a [routerLink]="['/contact-us']">Contact us </a>
                    <!-- <a routerLink="/">Community</a>
                <a routerLink="/">Blog</a> -->
                </li>
                <li>
                    <a href="https://calendly.com/admin-gradpilots/30min?month=2024-11" target="_blank">Join GradPilots
                    </a>
                    <a [routerLink]="['/contact-us']" [queryParams]="{purpose: 'help-center'}">Help center</a>
                                        <a [routerLink]="['/contact-us']" [queryParams]="{purpose: 'partnerships'}">Partnerships </a>

                    <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
                    <a [routerLink]="['/privacy-policy']">Terms & Conditions</a>
                </li>
            </ul>

            <dl>
                <dt>
                    <p>&copy; Copyright 2024 - GradPilots</p>
                </dt>
                <dt>
                </dt>
            </dl>
        </div>
    </div>
</footer>